import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DefaultOpeningClosingLastCallHour } from 'src/shared/models/default-opening-closing-hour.interface';
import { WorkingHourExtensions } from '../../../../shared/models/working-hours-extension.interface';
import {
  StateWrapper,
  setAsyncState,
} from '../../../../shared/utils/state-handling.utils';
import {ERROR, SUCCESS} from '../../../../shared/utils/state-messages.utils';
import { WorkingHoursExtensionsService } from './working-hours-extensions.service';

@Injectable({
  providedIn: 'root',
})
export class WorkingHoursExtensionsHttpHandler {
  constructor(
    private readonly workingHoursExtensionsService: WorkingHoursExtensionsService,
  ) {}

  saveWorkingHoursExtension(
    extension: WorkingHourExtensions,
  ): Observable<StateWrapper<any>> {
    return setAsyncState<any>(
      this.workingHoursExtensionsService.saveWorkingHoursExtension(extension),
      null,
      undefined,
      SUCCESS.SAVE_EXTENSION,
    );
  }

  getDefaultOpeningAndClosingHours(): Observable<DefaultOpeningClosingLastCallHour> {
    return this.workingHoursExtensionsService.getDefaultOpeningAndClosingHours();
  }

  deleteWorkingHoursExtension(
    id: number
  ): Observable<StateWrapper<any>> {
    return setAsyncState<any>(
      this.workingHoursExtensionsService.deleteWorkingHoursExtension(id),
      null,
      ERROR.DELETE_EXTENSION,
      SUCCESS.DELETE_EXTENSION,
    );
  }
}
